// main image slider 
jQuery(document).ready(function ($) {

  $('.tmp-xnest-prod-page-2 .product-gallery').each(function () {

    var $gallery = $(this);

    var thumbSwiper = new Swiper(
      $gallery.find('.product-thumb-slider')[0],
      {
        slidesPerView: 4,
        spaceBetween: 10,
        watchSlidesProgress: true,

        navigation: {
          nextEl: $gallery.find('.swiper-button-next')[0],
          prevEl: $gallery.find('.swiper-button-prev')[0]
        },

        breakpoints: {
          0: {
            slidesPerView: 4,
            spaceBetween: 8
          },

          750: {
            slidesPerView: 5,
            spaceBetween: 10
          },

          990: {
            slidesPerView: 5,
            spaceBetween: 10
          }
        }
      }
    );


    var mainSwiper = new Swiper(
      $gallery.find('.product-main-slider')[0],
      {
        slidesPerView: 1,
        spaceBetween: 10,

        thumbs: {
          swiper: thumbSwiper
        }
      }
    );

  });

});

// main product faq
$(document).ready(function () {

  // First FAQ open on page load
  var $first = $('.pdp_faq_item_list .faq_list').first();

  $first.addClass('active');
  $first.find('.faq_content').stop(true, true).slideDown(300);
  $first.find('.plus').hide();
  $first.find('.minus').show();


  // FAQ click
  $('.pdp_faq_item_list .faq_heading').on('click', function () {

    var $item = $(this).closest('.faq_list');

    // If already open, close it
    if ($item.hasClass('active')) {

      $item.removeClass('active');
      $item.find('.faq_content').stop(true, true).slideUp(300);
      $item.find('.plus').show();
      $item.find('.minus').hide();

      return;
    }

    // Close all other FAQs
    $('.pdp_faq_item_list .faq_list.active').each(function () {

      $(this).removeClass('active');
      $(this).find('.faq_content').stop(true, true).slideUp(300);
      $(this).find('.plus').show();
      $(this).find('.minus').hide();

    });

    // Open clicked FAQ
    $item.addClass('active');
    $item.find('.faq_content').stop(true, true).slideDown(300);
    $item.find('.plus').hide();
    $item.find('.minus').show();

  });

});


// short description
$(function () {
  $('.tmp-xnest-prod-page-2 .short_description').each(function () {
    var $description = $(this);
    var $button = $description.find('.description-toggle');

    // Move everything before the button into a wrapper
    var $content = $('<div class="description-content"></div>');

    $description.contents().each(function () {
      if (!$(this).is('.description-toggle')) {
        $content.append(this);
      }
    });

    $description.prepend($content);

    // Apply 3-line clamp
    $content.addClass('is-collapsed');

    // Hide button if content is already within 3 lines
    if ($content[0].scrollHeight <= $content[0].clientHeight) {
      $button.hide();
    }
  });

  $('.tmp-xnest-prod-page-2 .description-toggle').on('click', function () {
    var $button = $(this);
    var $description = $button.closest('.short_description');
    var $content = $description.find('.description-content');

    $content.toggleClass('is-collapsed');

    $button.text(
      $content.hasClass('is-collapsed')
        ? 'Read More'
        : 'Read Less'
    );
  });
});